<template>
  <div class="social">
    <h3>Social</h3>

    <div class="links">
      <a
        href="https://discord.gg/hi3"
        rel="nofollow noopener noreferrer"
        target="_blank"
        title="Discord"
      >
        <DiscordIcon class="simple-icons" /></a>
      <a
        href="https://www.facebook.com/HonkaiImpact3rd.fr"
        rel="nofollow noopener noreferrer"
        target="_blank"
        title="Facebook"
      >
        <FacebookIcon class="simple-icons" /></a>
      <a
        href="https://www.instagram.com/honkaiimpact3rd/"
        rel="nofollow noopener noreferrer"
        target="_blank"
        title="Instagram"
      >
        <InstagramIcon class="simple-icons" /></a>
      <a
        href="https://www.twitter.com/HonkaiImpact3rd"
        rel="nofollow noopener noreferrer"
        target="_blank"
        title="X (Twitter)"
      >
        <XIcon class="simple-icons" /></a>
      <a
        href="https://www.youtube.com/@HonkaiImpact3rd"
        rel="nofollow noopener noreferrer"
        target="_blank"
        title="YouTube"
      >
        <YoutubeIcon class="simple-icons" /></a>
      <a
        href="https://www.twitch.tv/honkaiimpact3rdofficial"
        rel="nofollow noopener noreferrer"
        target="_blank"
        title="Twitch"
      >
        <TwitchIcon class="simple-icons" /></a>
      <a
        href="https://www.hoyolab.com/explore/1"
        rel="nofollow noopener noreferrer"
        target="_blank"
        title="HoYoLab"
      >
        <HoYoLabIcon
          class="simple-icons"
          role="img"
        /></a>
      <a
        href="https://www.reddit.com/r/HonkaiImpact3rd/"
        rel="nofollow noopener noreferrer"
        target="_blank"
        title="Reddit"
      >
        <RedditIcon class="simple-icons" /></a>
    </div>
  </div>
</template>

<script lang="ts" setup>
// Icons
import {
  DiscordIcon,
  FacebookIcon,
  InstagramIcon,
  RedditIcon,
  TwitchIcon,
  XIcon,
  YoutubeIcon,
} from '@mkody/vue3-simple-icons'
import HoYoLabIcon from '@/components/hoyolab.svg?component'
</script>

<style scoped lang="scss">
.social {
  margin-bottom: 2em;

  .links {
    a {
      color: inherit;
      display: inline-block;
      margin-right: 1em;
      text-decoration: none;

      &:hover {
        color: #ffa827;
      }

      & > svg {
        height: 1.25rem;
        width: auto;
      }
    }
  }
}
</style>
